$(function () {
  // Add a class to the parent elements of the subcategories
  $(
    '.product-attributes-filters__group > .product-attributes-filters__group__terms > .product-attributes-filters__group__terms__parent'
  ).addClass('level-1');

  $(document).on(
    'click',
    '.product-attributes-filters__group__terms__parent__toggle',
    function () {
      var $this = $(this);
      var parent = $this.closest(
        '.product-attributes-filters__group__terms__parent'
      );
      var icon = $this.find('i'); // Target the <i> element inside the toggle

      // Check if the current menu is open (fa-minus)
      if (icon.hasClass('fa-minus')) {
        parent
          .children('.product-attributes-filters__group__terms__parent__childs')
          .slideUp();
        icon.removeClass('fa-minus').addClass('fa-plus');
      } else {
        parent
          .children('.product-attributes-filters__group__terms__parent__childs')
          .slideDown();
        icon.removeClass('fa-plus').addClass('fa-minus');
      }
    }
  );

  // Filter attributes
  $(document).on(
    'click',
    '.product-attributes-filters__group__attribute__option a',
    function (e) {
      e.preventDefault();

      var $this = $(this);
      var taxonomy = $this
        .closest('.product-attributes-filters__group__attribute__option')
        .data('taxonomy');
      var term = $this
        .closest('.product-attributes-filters__group__attribute__option')
        .data('term');
      var currentUrl = new URL(window.location.href);
      var urlParams = new URLSearchParams(currentUrl.search);

      // Get existing selected values for the attribute
      var selectedValues = urlParams.get(taxonomy)
        ? urlParams.get(taxonomy).split(',')
        : [];

      // Check if the term is already selected
      if (selectedValues.includes(term)) {
        selectedValues = selectedValues.filter(function (val) {
          return val !== term;
        });
      } else {
        selectedValues.push(term);
      }

      // Get the list of valid terms for this taxonomy
      var validTerms = [];
      $(
        '.product-attributes-filters__group__attribute__option[data-taxonomy="' +
          taxonomy +
          '"]'
      ).each(function () {
        validTerms.push($(this).data('term'));
      });

      // Remove terms from the URL that are not in the list of valid terms
      selectedValues = selectedValues.filter(function (val) {
        return validTerms.includes(val);
      });

      // Update the URL with the new list of selected values
      if (selectedValues.length) {
        urlParams.set(taxonomy, selectedValues.join(','));
      } else {
        urlParams.delete(taxonomy);
      }

      // Remove pagination (page/x) from the path
      currentUrl.pathname = currentUrl.pathname.replace(/\/page\/\d+/, '');

      // Set the new URL
      currentUrl.search = urlParams.toString();
      window.location.href = currentUrl.toString();
    }
  );

  // Store scroll position before navigating
  $(document).on(
    'click',
    '.product-attributes-filters__group__terms__parent__link, .product-attributes-filters__group__attribute__option a',
    function () {
      if ($('.product-attributes-filters').length) {
        sessionStorage.setItem('scrollPosition', $(window).scrollTop());
      }
    }
  );

  // Restore scroll position on page load
  $(document).ready(function () {
    if ($('.product-attributes-filters').length) {
      var scrollPosition = sessionStorage.getItem('scrollPosition');
      if (scrollPosition) {
        $(window).scrollTop(scrollPosition);

        // Remove scroll position after scrolling to it (one-time use)
        sessionStorage.removeItem('scrollPosition');
      }
    }
  });
});
